import validate from '../../../services/reduxValidate.js';

export default function(data) {

  let rules = {
    'firstname': { presence: { allowEmpty: false } },
    'lastname': { presence: { allowEmpty: false } },
    'date_of_birth': { isoDate: true },
    'fonction': { presence: { allowEmpty: false } },
    'tel' :{
      presence: { allowEmpty: false },
      format: {
        pattern: /^\+?([0-9.\-\s]+)$/g,
        message: "Le numéro de téléphone est invalide"
      }
    },
    'organization.name': { presence: { allowEmpty: false } }
  }

  if (data.isBusinessManager) {
    rules =
      {
        ...rules,
        'calendly_url': {
          presence: {allowEmpty: false},
          format: {
            pattern: /^(https:\/\/calendly.com\/)[-a-zA-Z0-9@:%._+~#=]{1,235}/gi,
            message: "Le lien calendly est invalide"
          }
        }
      }
  }

  return validate(data, rules);
}